import api from "PFCore/api";
import { Id } from "PFTypes";
import { FiltersConfigTemplate } from "PFTypes/filters_config";

const url = (accountId: Id, target: string) => `saas_admin/accounts/${accountId}/configs/forms/${target}`;

export const fetchFiltersConfigForm = (accountId: Id): Promise<FiltersConfigTemplate> =>
  api({
    url: url(accountId, "filters")
  });

export const fetchOrderConfigForm = (accountId: Id): Promise<FiltersConfigTemplate> =>
  api({
    url: url(accountId, "order_options")
  });
